import { ReactElement, useMemo, useEffect } from 'react';
import { Collapse, Stack, Typography } from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';

import { useToggle } from '~hooks/useToggle';
import { toAbsoluteUrl } from '~utils/assetsHelpers';

import { useDashboardVariantV2GiverContext } from '../Context';

import {
  DashboardVariantV2GiverConnectYourStoreBannerContainer,
  DashboardVariantV2GiverConnectYourStoreBannerImage,
  DashboardVariantV2GiverConnectYourStoreBannerCloseButton,
  DashboardVariantV2GiverConnectYourStoreBannerActionButton,
} from './styles';

const DashboardVariantV2GiverConnectYourStoreBanner = (): ReactElement => {
  const {
    integrations: { data: integrations },
    dialogs: {
      integrations: { toggleOpen: toogleOpenDialogIntegrations },
    },
  } = useDashboardVariantV2GiverContext();

  const [expanded, toggleExpanded] = useToggle(false);

  const hasIntegrations = useMemo(
    () => integrations.length > 0,
    [integrations.length],
  );

  useEffect(() => {
    toggleExpanded(!hasIntegrations);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasIntegrations]);

  return (
    <Collapse in={expanded} timeout="auto" unmountOnExit>
      <DashboardVariantV2GiverConnectYourStoreBannerContainer>
        <DashboardVariantV2GiverConnectYourStoreBannerImage
          src={toAbsoluteUrl('/images/integrations_availables.png')}
          alt="Integrations Availables"
        />

        <DashboardVariantV2GiverConnectYourStoreBannerCloseButton
          aria-label="close"
          onClick={() => toggleExpanded(false)}
          size="small"
        >
          <CloseIcon />
        </DashboardVariantV2GiverConnectYourStoreBannerCloseButton>

        <Stack spacing={0.5}>
          <Typography component="h6" variant="subtitle1" fontWeight="bold">
            CONECTA TUS TIENDAS PARA GESTIONAR TUS VENTAS MÁS FÁCILMENTE
          </Typography>

          <Typography variant="subtitle2">
            Integrarnos con tus tiendas nos permite{' '}
            <b>gestionar mejor tus ventas</b> y{' '}
            <b>agilizar los tiempos de colecta y distribución.</b>
          </Typography>
        </Stack>

        <DashboardVariantV2GiverConnectYourStoreBannerActionButton
          variant="contained"
          color="inherit"
          onClick={() => toogleOpenDialogIntegrations(true)}
        >
          Conectar mis tiendas
        </DashboardVariantV2GiverConnectYourStoreBannerActionButton>
      </DashboardVariantV2GiverConnectYourStoreBannerContainer>
    </Collapse>
  );
};

export default DashboardVariantV2GiverConnectYourStoreBanner;
